import { Timer } from "lucide-react";
import { useEffect, useState } from "react";
import { useCopy } from "../i18n/copy";

export function Countdown({
  finishAt,
  compact = false,
}: {
  finishAt?: number | string;
  compact?: boolean;
}) {
  const { tr } = useCopy();
  const target = Number(finishAt || 0);
  const remaining = () =>
    Math.max(0, Math.floor(target - Date.now() / 1000));
  const [seconds, setSeconds] = useState(remaining);

  useEffect(() => {
    setSeconds(remaining());
    if (!target) return;
    const timer = window.setInterval(() => setSeconds(remaining()), 1000);
    return () => window.clearInterval(timer);
  }, [target]);

  if (!target || seconds <= 0) return null;
  const day = Math.floor(seconds / 86400);
  const hour = Math.floor((seconds % 86400) / 3600);
  const minute = Math.floor((seconds % 3600) / 60);
  const second = seconds % 60;
  const values = [
    day > 0 ? String(day) + "d" : "",
    String(hour).padStart(2, "0"),
    String(minute).padStart(2, "0"),
    String(second).padStart(2, "0"),
  ].filter(Boolean);

  return (
    <div className={compact ? "countdown compact" : "countdown"}>
      <Timer />
      <small>{tr("Finaliza en")}</small>
      <strong>{values.join(" : ")}</strong>
    </div>
  );
}
